import React from 'react'

import { CustomTheme, greenPrimary } from '@masfront/common-b2c'

import { FormControl, Select, Box, InputLabel, MenuItem } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/styles'

import formatBonusFee from './BonusesAvailableModal.helpers'

import { BonusType } from '~/bonus/model/bonus.model'

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(3, 0),
      width: theme.spacing(115),
      '& .MuiSelect-select:focus': {
        background: 'none',
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: greenPrimary,
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: greenPrimary,
      },
    },
    selectOutlined: {
      display: 'flex',
      justifyContent: 'space-between',
      '& .MuiTypography-root': {
        paddingRight: theme.spacing(4),
      },
    },
    bonusesAndPrices: {
      justifyContent: 'space-between',
    },
  }),
)

export interface BonusAvailableSelectProps {
  bonuses?: BonusType[]
  bonusSelectedId: string
  onChangeBonus?: (bonusId: string) => void
}

const BonusAvailableSelect: React.FC<BonusAvailableSelectProps> = ({
  bonuses = [],
  bonusSelectedId = '',
  onChangeBonus = () => ({}),
}) => {
  const classes = useStyles()
  const styleClasses = {
    selectOutlined: classes.selectOutlined,
  }

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel htmlFor="outlined-age-native-simple">Bono</InputLabel>
      <Select
        data-hook="bonus-select"
        classes={{ outlined: styleClasses.selectOutlined }}
        value={bonusSelectedId}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(event: any) => onChangeBonus(event.target.value)}
        label="Bono"
      >
        {bonuses.map((bonus, i) => (
          <MenuItem
            key={bonus.id}
            data-hook={`menu-item-${i}`}
            className={classes.bonusesAndPrices}
            value={bonus.id}
          >
            <Box>{bonus.name}</Box>
            <Box>{` ${formatBonusFee(bonus)}`}</Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default BonusAvailableSelect
